interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  accent?: boolean;
}

export default function SectionHeader({ eyebrow, title, desc, accent }: Props) {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
      <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-700 uppercase">
        <span className="inline-block h-px w-8 bg-primary-500" />
        {eyebrow}
      </p>
      <h2 className="font-heading mt-3 text-2xl font-black leading-tight text-foreground-950 sm:text-3xl md:text-4xl">
        {title}
        {accent && <span className="text-primary-600">。</span>}
      </h2>
      {desc && (
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      )}
    </div>
  );
}